class DesignSummaryComponent extends HTMLElement {

  constructor() {
    super();
    document.addEventListener('analysis-failed', (event) => {
      document.getElementById('design-failed-alert').classList.remove('d-none')
      document.getElementById('design-success-alert').classList.add('d-none')
      
      document.getElementById('design-failed-title').innerHTML = 'Analysis Failed'
      document.getElementById('design-failed-message').innerHTML = event.detail
    
      document.querySelectorAll(".current-design-status").forEach(element => {
        element.innerHTML = `<i class="fa fa-remove"></i> Design Failed`;
      });
    })

    document.addEventListener('design-failed', (event) => {
      document.getElementById('design-failed-alert').classList.remove('d-none')
      document.getElementById('design-success-alert').classList.add('d-none')
      
      document.getElementById('design-failed-title').innerHTML = event.detail.title
      document.getElementById('design-failed-message').innerHTML = event.detail.message
    })

    document.addEventListener('analysis-started', () => {
      document.getElementById('design-failed-alert').classList.add('d-none')
      document.getElementById('design-success-alert').classList.remove('d-none')
    })

    document.addEventListener('design-success', (event) => {
      document.getElementById('design-success-message').innerHTML = event.detail
    })
  }

  connectedCallback() {
    this.innerHTML = String.raw`
    <div class="row my-1" id="design-success-alert">
        <div class="col">
          <div class="alert alert-success d-flex align-items-start gap-3" role="alert">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-check" viewBox="0 0 16 16">
              <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425z"/>
            </svg>
            <div>
              <h5 class="alert-heading mb-1" >Design Passed</h5>
              <p class="mb-0">
                <span id="design-success-message">LRFD W8X15 A992</span>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="row my-1 d-none" id="design-failed-alert">
        <div class="col">
          <div class="alert alert-danger d-flex align-items-start gap-3" role="alert">
            <svg class="bi flex-shrink-0 me-2 mt-2" width="24" height="24" role="img" aria-label="Danger:"><use xlink:href="#exclamation-triangle-fill"/></svg>
            <div>
              <h5 class="alert-heading mb-1" id="design-failed-title">Beam Design Failed</h5>
              <p class="mb-0" id="design-failed-message">
                This beam does not meet code requirements. 
              </p>
            </div>
          </div>
        </div>
      </div>
    `
  }

}

customElements.define('design-summary-component', DesignSummaryComponent)

